// extracted by mini-css-extract-plugin
export default {"authContainer":"VoiceComplete_authContainer__z0d3-","authTitle":"VoiceComplete_authTitle__kKjw1"};